var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67363 9.27278L2.34365 8.94279C2.0936 8.69275 1.95313 8.35361 1.95313 7.99998C1.95313 7.64636 2.0936 7.30722 2.34365 7.05718L7.05769 2.34313C7.30774 2.09308 7.64688 1.95261 8.0005 1.95261C8.35413 1.95261 8.69326 2.09308 8.94331 2.34313L13.6574 7.05718C13.9074 7.30722 14.0479 7.64636 14.0479 7.99999C14.0479 8.35361 13.9074 8.69275 13.6574 8.94279L8.94331 13.6568C8.69326 13.9069 8.35413 14.0474 8.0005 14.0474C7.64688 14.0474 7.30774 13.9069 7.05769 13.6568L4.70067 11.2998M4.70067 11.2998L4.70067 13.9585M4.70067 11.2998L7.35939 11.2998",
    stroke: "#E7E3D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.8669cd256c3d2611a3615b708aafdcc9.svg";
export { ForwardRef as ReactComponent };